import { t } from '@framework/i18n';
import type { CardTabListType } from 'antd/es/card';

interface SubmissionSentTabListOptions {
  shouldShowCommunicationsTab: boolean;
  shouldShowIntegrationsTab: boolean;
  shouldShowPaymentsTab: boolean;
}

export const getSubmissionSentTabList = (
  options: SubmissionSentTabListOptions,
) => {
  const {
    shouldShowCommunicationsTab,
    shouldShowIntegrationsTab,
    shouldShowPaymentsTab,
  } = options;

  const activeTabKeys = [
    'receipt',
    'request',
    ...(shouldShowCommunicationsTab ? ['communications'] : []),
    ...(shouldShowIntegrationsTab ? ['integrations'] : []),
    ...(shouldShowPaymentsTab ? ['payments'] : []),
  ];

  return [
    {
      key: 'receipt',
      label: (
        <span
          aria-label={t(
            'submission-details.ricevuta-invio-aria-label',
            'Ricevuta invio. Tab {{tabNumber}} di {{totalTabs}}',
            {
              tabNumber: 1,
              totalTabs: activeTabKeys.length,
            },
          )}
        >
          {t('submission-details.ricevuta-invio', 'Ricevuta invio')}
        </span>
      ),
    },
    {
      key: 'request',
      label: (
        <span
          aria-label={t(
            'submission-details.la-mia-richiesta-aria-label',
            'La mia richiesta. Tab {{tabNumber}} di {{totalTabs}}',
            {
              tabNumber: 2,
              totalTabs: activeTabKeys.length,
            },
          )}
        >
          {t('submission-details.la-mia-richiesta', 'La mia richiesta')}
        </span>
      ),
    },
    ...(shouldShowCommunicationsTab
      ? [
          {
            key: 'communications',
            label: (
              <span
                aria-label={t(
                  'submission-details.comunicazioni-aria-label',
                  'Comunicazioni. Tab {{tabNumber}} di {{totalTabs}}',
                  {
                    tabNumber: activeTabKeys.indexOf('communications') + 1,
                    totalTabs: activeTabKeys.length,
                  },
                )}
              >
                {t('submission-details.comunicazioni', 'Comunicazioni')}
              </span>
            ),
          },
        ]
      : []),
    ...(shouldShowIntegrationsTab
      ? [
          {
            key: 'integrations',
            label: (
              <span
                aria-label={t(
                  'submission-details.integrazioni-aria-label',
                  'Integrazioni. Tab {{tabNumber}} di {{totalTabs}}',
                  {
                    tabNumber: activeTabKeys.indexOf('integrations') + 1,
                    totalTabs: activeTabKeys.length,
                  },
                )}
              >
                {t('submission-details.integrazioni', 'Integrazioni')}
              </span>
            ),
          },
        ]
      : []),
    ...(shouldShowPaymentsTab
      ? [
          {
            key: 'payments',
            label: (
              <span
                aria-label={t(
                  'submission-details.pagamenti-aria-label',
                  'Pagamenti. Tab {{tabNumber}} di {{totalTabs}}',
                  {
                    tabNumber: activeTabKeys.indexOf('payments') + 1,
                    totalTabs: activeTabKeys.length,
                  },
                )}
              >
                {t('submission-details.pagamenti', 'Pagamenti')}
              </span>
            ),
          },
        ]
      : []),
  ] as CardTabListType[];
};
